var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Meter from "syf-component-library/ui/patterns/Meter";
import { formatCurrency } from "syf-js-utilities";
import { Body, Grid } from "syf-component-library/ui";
import { useTranslation } from "react-i18next";
import { Inset } from "syf-component-library/ui/spacing";
import useFeaturedContentData from "../../../hooks/useFeaturedContentData";
import { meterWidth } from "../../../const";
import { MeterContainer, MeterFooter, TopDetailsContainer, HeaderBottomSpace, HeaderTopSpace, VerticalLine, } from "./subcomponents";
import useIsTablet from "../../../hooks/useIsTablet";
import DataElement from "../../atoms/DataElement/DataElement";
import DescriptionList from "../../atoms/DescriptionList";
export var FeaturedContentWithMeter = function () {
    var _a;
    var t = useTranslation().t;
    var isTablet = useIsTablet();
    var _b = useFeaturedContentData(), hasMeter = _b.hasMeter, primary = _b.primary, secondary = _b.secondary;
    if (!hasMeter) {
        return _jsx("div", {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(HeaderTopSpace, {}), _jsxs(Grid, __assign({ direction: isTablet ? "row" : "column" }, { children: [_jsx(Grid, __assign({ item: true }, { children: _jsxs(MeterContainer, { children: [_jsx(Meter, { percentage: (_a = primary === null || primary === void 0 ? void 0 : primary.percent) !== null && _a !== void 0 ? _a : 0, label: primary === null || primary === void 0 ? void 0 : primary.label, width: meterWidth, labelFontSize: 18 }), _jsxs(MeterFooter, { children: [_jsx(Body, __assign({ "data-cy": "credit-limit-label" }, { children: t("grid.creditLimit") })), _jsx(Body, __assign({ "data-cy": "credit-limit-amount" }, { children: (primary === null || primary === void 0 ? void 0 : primary.creditLimit)
                                                ? formatCurrency(primary === null || primary === void 0 ? void 0 : primary.creditLimit)
                                                : undefined }))] })] }) })), isTablet ? (_jsx(VerticalLine, { "data-testid": "verticalLine" })) : (_jsx(Inset, { "data-testid": "insetLine" })), _jsx(Grid, __assign({ item: true }, { children: _jsx(TopDetailsContainer, { children: _jsx(DescriptionList, { children: secondary.map(function (_a) {
                                    var label = _a.label, value = _a.value, toolTipText = _a.toolTipText, type = _a.type;
                                    return (_jsx(DataElement, { dataCy: "secondary-featured-content.data-element", label: label, value: value, type: type, toolTipText: toolTipText }, label));
                                }) }) }) }))] })), _jsx(HeaderBottomSpace, {})] }));
};
//# sourceMappingURL=FeaturedContentWithMeter.js.map